export default {
  computed: {
    formfields () {
      return [
        {
          text: 'Liberado',
          value: 'liberado',
          width: '200px',
          required: true,
          select: [
            { text: 'Sim', value: 'S' },
            { text: 'Não', value: 'N' }
          ]
        }
      ]
    }
  }
}
